import type { DrawingProps } from "./types";

/** What the read does: looks closely, at one thing. */
export function Magnifier({ size = 64, className, title }: DrawingProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      className={className}
      role={title ? "img" : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
    >
      <circle cx="27" cy="27" r="17" fill="var(--sky-tint)" stroke="var(--ink)" strokeWidth="2.5" />
      <path d="M20 24h14M20 31h9" stroke="var(--sage-deep)" strokeWidth="2.5" strokeLinecap="round" />
      <path d="M39 39 54 54" stroke="var(--ink)" strokeWidth="2.5" strokeLinecap="round" />
      <path d="M15 20a13 13 0 0 1 8-7" stroke="var(--white)" strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  );
}
